module.exports = __webpack_public_path__ + "img/img_app_01_feature1.d56ec57b.png";